/**
 * Carousel
 * https://swiperjs.com/
 */

import Swiper, { Autoplay, Pagination, EffectCards } from 'swiper';

let swiperCarousel = undefined;

export default function carousel() {

    // When Carousel exists
    if (carousel) {
        let $obj = $('.carousel');

        function insertSlider(loop) {

            if (!$obj.length) return;

            const swiperCarousels = document.querySelectorAll(".swiper-carousel");

            swiperCarousels.forEach(carouselContainer => {
                let $this = $(carouselContainer);
                let sliderLoop = loop;

                const carouselPagination = carouselContainer.querySelector(
                    ".swiper-pagination"
                );

                const carouselPrevButton =
                    carouselContainer.querySelector(".swiper-button-prev") ||
                    carouselContainer.parentElement.querySelector(
                        ".swiper-button-prev" // <-- this is how you can have the Prev Button outside the swiper container
                    );

                const carouselNextButton =
                    carouselContainer.querySelector(".swiper-button-next") ||
                    carouselContainer.parentElement.querySelector(
                        ".swiper-button-next" // <-- this is how you can have the Next Button outside the swiper container
                    );

                if (!$this.hasClass('swiper-horizontal')) {

                    // let effect = 'cards'
                    // if (sliderLoop === false) {
                    //     effect = 'slide'
                    // }
                    swiperCarousel = new Swiper(carouselContainer, {
                        modules: [Autoplay, Pagination, EffectCards],
                        effect: 'cards',
                        grabCursor: true,
                        loop: sliderLoop,
                        // loop: true,
                        autoplay: {
                            delay: 1500,
                            pauseOnMouseEnter: true,
                            stopOnLastSlide: true
                        },
                        lazy: {
                            loadPrevNext: true,
                            loadPrevNextAmount: 10,
                        },
                        cardsEffect: {},
                        pagination: {
                            el: carouselPagination,
                            clickable: true,
                            dynamicBullets: true
                        },
                        breakpoints: {
                            767: {
                                cardsEffect: {

                                },
                            },
                            991: {
                                cardsEffect: {

                                },
                            }
                        }
                    });
                }
            });
        }

        function insertSlides() {
            if (!$obj.length) return;

            // if (isOnScreen.call($obj) === true) {

            if (!$obj.find('.swiper').hasClass('swiper-horizontal')) {
                let serverTime = $('#serverTime').val().toString();
                let GivenDate;
                let endDate = new Date('2023-04-29');
                GivenDate = new Date(serverTime);


                // console.log(endDate)
                // console.log(GivenDate)

                if (GivenDate > endDate) {
                    // console.log('Given date is greater than the current date.');
                    $('.app-coupon > .row').remove();
                    $('.app-coupon > .d-block.d-lg-none').remove();
                } else {
                    // console.log('Given date is not greater than the current date.');
                    // $obj.removeClass('d-none');

                    $.getJSON('/assets/data/slider-products.json', function(data) {

                        for (let key in data) {
                            if (key === serverTime) {
                                $('.carousel .swiper-wrapper').append(data[key]);

                                if (key === '2023-04-29') {
                                    $('.carousel').addClass('only-one-item');
                                    insertSlider(false);
                                } else {
                                    insertSlider(true);
                                }
                                break;
                            }

                        }
                    })
                }
            }
            // }
        }

        // setTimeout(() => {
        insertSlides();
        // }, "1000");


        // $(window).on("scroll", function() {
        //     insertSlides();
        // });

        // insertSlider();
    }
}
